import * as React from "preact";
import { JSX } from "preact";

export interface IconContext {
  color?: string;
  size?: string;
  class?: string;
  stroke?: string | JSX.SignalLike<string | undefined>; // allow overide stroke color "currentColor"
  fill?: string | JSX.SignalLike<string | undefined>; // allow overide fill color "currentColor"
  strokeWidth?:  number | string | JSX.SignalLike<number | string | undefined>; // allow overide strokeWidth default 0

  style?: JSX.CSSProperties;
  attr?: JSX.SVGAttributes<SVGSVGElement>;
}

export const defaultContext: IconContext = {
  color: undefined,
  size: undefined,
  class: undefined,
  style: undefined,
  attr: undefined,
};

export const defaultIconContext: React.Context<IconContext> = React.createContext && React.createContext(defaultContext);

// denoCacheMetadata={"headers":{"date":"Tue, 25 Feb 2025 18:13:35 GMT","age":"1202328","cross-origin-resource-policy":"cross-origin","x-served-by":"cache-fra-etou8220096-FRA, cache-pao-kpao1770054-PAO","cache-control":"public, max-age=31536000, s-maxage=31536000, immutable","access-control-allow-origin":"*","access-control-expose-headers":"*","x-jsd-version":"1.0.8","content-type":"text/plain; charset=utf-8","x-jsd-version-type":"version","alt-svc":"h3=\":443\";ma=86400,h3-29=\":443\";ma=86400,h3-27=\":443\";ma=86400","x-cache":"HIT, HIT","timing-allow-origin":"*","x-content-type-options":"nosniff","etag":"W/\"32a-Bmotoc1mE42JAxp+yFUNnwalsPg\"","accept-ranges":"bytes","strict-transport-security":"max-age=31536000; includeSubDomains; preload","vary":"Accept-Encoding"},"url":"https://cdn.jsdelivr.net/gh/urielch/react-icons@1.0.8/lib/iconContext.ts","time":1740507215}